/** @flow */

import type { State } from "@store/reducers";

export const getDashboardFirstCareIndexPageStatistic = (state: State) =>
  ((state.reporting || {}).dashboard || {}).firstcareIndexPageStatistic;

export const isLoading = (state: State): boolean =>
  ((state.reporting || {}).dashboard || {}).requestsInProgress > 0;

export const getHierarchyBreakdown = (state: State) => {
  return state.reporting.dashboard.hierarchyBreakdown.content;
};

export const getIsAbsencesLoading = (state: State) =>
  state.reporting.dashboard.absenceNow.requestsInProgress > 0;

export const getIsHierarchyBreakdownLoading = (state: State) =>
  state.reporting.dashboard.hierarchyBreakdown.requestsInProgress > 0;

export const getIsDashboardToolsLoading = (state: State) =>
  state.reporting.dashboard.overview.requestsInProgress > 0;
